import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About Me`}</h2>
    <blockquote>
      <p parentName="blockquote">{`The English language can not fully capture the depth and complexity of my thoughts. So I'm incorporating Emoji into my speech to better express myself. Winky face.`}</p>
    </blockquote>
    <p>{`You know the way you feel when you see a picture of two otters holding hands? That's how you're gonna
feel every day. My mother cried the day I was born because she knew she’d never be prettier than me.
You should make me your campaign manager. I was born for politics. I have great hair and I love lying.
Captain? The kids want to know where Paulie the Pigeon is.
I told them he got sucked up into an airplane engine, is that all right?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      